package pl.zar.tikthrow.ui.theme

import androidx.compose.material3.darkColorScheme
import androidx.compose.ui.graphics.Color

// Single flat accent — reserved for key places only (primary actions, active nav, brand mark)
val Accent = Color(0xFF7C5CFC)  // single-tone violet — the one spot of color, no more dual-tone gradient

// Backward-compat aliases: both point at the same flat accent (no more two-tone gradient)
val GradientStart = Accent
val GradientEnd = Accent

val Indigo400 = Accent  // backward-compat alias

// True neutral grayscale — raw / monochromatic (50 = darkest, 900 = lightest)
val Slate50  = Color(0xFF0A0A0A)  // main background
val Slate100 = Color(0xFF141414)  // card / surface
val Slate200 = Color(0xFF212121)  // borders, dividers
val Slate300 = Color(0xFF2E2E2E)  // subtle / disabled
val Slate400 = Color(0xFF6E6E6E)  // icons, placeholders
val Slate500 = Color(0xFF9A9A9A)  // secondary text
val Slate600 = Color(0xFFBDBDBD)  // medium text
val Slate800 = Color(0xFFE4E4E4)  // body text
val Slate900 = Color(0xFFF7F7F7)  // primary text

// Kept for compat
val Zinc950 = Color(0xFF0A0A0A)
val Rose500 = Color(0xFFF87171)
val Amber400 = Color(0xFFFBBF24)
val Emerald500 = Color(0xFF34D399)  // success/published status

val TikThrowDarkColorScheme = darkColorScheme(
    primary              = Accent,
    onPrimary            = Color.White,
    primaryContainer     = Slate200,
    onPrimaryContainer   = Accent,
    secondary            = Slate500,
    onSecondary          = Slate50,
    secondaryContainer   = Slate200,
    onSecondaryContainer = Slate800,
    tertiary             = Slate600,
    onTertiary           = Slate50,
    tertiaryContainer    = Slate200,
    onTertiaryContainer  = Slate800,
    error                = Rose500,
    onError              = Color.White,
    errorContainer       = Color(0xFF7F1D1D),
    onErrorContainer     = Color(0xFFFFE4E6),
    background           = Slate50,
    onBackground         = Slate900,
    surface              = Slate100,
    onSurface            = Slate900,
    surfaceVariant       = Slate200,
    onSurfaceVariant     = Slate500,
    outline              = Slate300,
    outlineVariant       = Slate200,
)
